import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import TechnicalSidebar from './TechnicalSidebar';

function PanelFormation() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 bg-light mt-5" id="panel-formation">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9 col-md-8 col-12 mb-4" data-aos="fade-up">
            <div className="text-center mb-4">
              <h2 className="fw-bold">Panel Formation Explained</h2>
              <p className="text-muted">
                Understanding the process and types of energy panel configurations.
              </p>
            </div>

            {/* Panel Image */}
            <div className="mb-4 text-center" data-aos="zoom-in">
              <img
                src="https://essentialparts.com/cdn/shop/articles/eletric-panels_900x.jpg?v=1722315904"
                alt="Energy Panels"
                className="img-fluid rounded shadow"
                style={{ maxHeight: '350px', objectFit: 'cover', width: '100%' }}
              />
            </div>

            <div className="mb-4" data-aos="fade-up">
              <p className="text-muted lead">
                Panel formation refers to the process of arranging and configuring energy panels—such as solar, power distribution, or control panels—into a structured system. This setup ensures optimal performance, safety, and reliability by managing installation, wiring, and configuration.
              </p>
            </div>

            {/* AC Distribution Box */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-primary">AC Distribution Box</h4>
              <p>
                Electrical panel formation involves designing panels that direct the flow of electricity across circuits in a building or industrial setup. These panels often include circuit breakers, transformers, and meters for efficient distribution and protection.
              </p>
            </div>

            {/* Solar Panel Formation */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-success">Solar Panel Formation</h4>
              <p>
                In solar systems, panel formation arranges photovoltaic panels into arrays to maximize sun exposure. These configurations—either in series or parallel—ensure sufficient voltage and current to meet energy needs while prolonging system life.
              </p>
            </div>

            {/* Control Panel Formation */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-info">Control Panel Formation</h4>
              <p>
                Used in industrial setups, control panels contain switches, sensors, displays, and safety elements. Panel formation helps organize these components ergonomically, making them easier to operate and maintain.
              </p>
            </div>

            {/* CTA Box */}
            <div
              className="p-4 bg-white border-start border-4 border-primary rounded shadow-sm"
              data-aos="fade-up"
            >
              <h5 className="text-dark fw-semibold">Technical Tables</h5>
              <p className="text-muted mb-2">Explore more about electrical components & standards.</p>

              {/* Optional Social Icons (if needed) */}
              <div className="d-flex gap-2 mt-2">
                {/* Example social buttons (React Icons + hover) */}
                <a
                  href="#"
                  className="btn btn-light rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: 40, height: 40, borderColor: '#08717A' }}
                >
                  <i className="fab fa-facebook-f text-primary"></i>
                </a>
                <a
                  href="#"
                  className="btn btn-light rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: 40, height: 40, borderColor: '#08717A' }}
                >
                  <i className="fab fa-linkedin-in text-primary"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <TechnicalSidebar />
        </div>
      </div>
    </section>
  );
}

export default PanelFormation;
